import { render, staticRenderFns } from "./CancelSuccessOrder.vue?vue&type=template&id=22aee74d"
import script from "./CancelSuccessOrder.vue?vue&type=script&lang=js"
export * from "./CancelSuccessOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports